import { render, staticRenderFns } from "./InvestorTaxProfileData.vue?vue&type=template&id=a61b0e24&"
import script from "./InvestorTaxProfileData.vue?vue&type=script&lang=js&"
export * from "./InvestorTaxProfileData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports